import { call, put, takeEvery } from "redux-saga/effects";
import { login } from "../../api/auth";
import { IAuth, IUser } from "../../interfaces/auth";
import { IAction } from "../utils";
import { loginAction } from "./actions";
import { sagaTypes } from "./types";

export function* loginWorkerSaga({ payload }: IAction<IUser>) {
  const res: IAuth = yield call(login, payload as IUser);
  yield put(loginAction(res || {}));
}

// export function* logoutWorkerSaga({ payload }: IAction<string>) {}

export function* authWatcherSaga() {
  yield takeEvery(sagaTypes?.LOGIN, loginWorkerSaga);
}
